import { SxProps, Theme } from "@mui/material/styles";
import theme, { erreur, yellow } from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.statut": {
      padding: "2px 8px",
      fontSize: 11,
      borderRadius: "2px",
      fontWeight: 500,
      whiteSpace: "nowrap",
      textAlign: "center",
    },
    "&.green": {
      background: theme.palette.primary.main,
      color: "#FFF",
    },
    "&.orange": {
      background: yellow,
    },
    "&.red": {
      background: erreur,
      color: "white",
    },
  },
];

export default styles;
